// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c5lZ","expireSoon":"styles_expireSoon__3hpQ4"};